import React from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

import { useDidMountEffect } from './index';
export default (module, season, reloadConfig) => {
  const { olOrderHiddenColumns,
    zsOrderHiddenColumns,
    plOrderHiddenColumns,
    wrOrderHiddenColumns,
    olOrderColumnsWidth,
    zsOrderColumnsWidth,
    plOrderColumnsWidth,
    wrOrderColumnsWidth,
    olOrderColumnsSequence,
    zsOrderColumnsSequence,
    plOrderColumnsSequence,
    wrOrderColumnsSequence,
    olOrderFilters,
    zsOrderFilters,
    plOrderFilters,
    wrOrderFilters,
    olOrderSearchFields,
    zsOrderSearchFields,
    plOrderSearchFields,
    wrOrderSearchFields } = useSelector(state => state.employeeOrderConfig);
  const [config, setConfig] = React.useState({
    orderHiddenColumns: {},
    orderColumnsWidth: {},
    orderColumnsSequence: {},
    orderFilters: {},
    orderSearchFields: {}
  });
  const [reload, setReload] = React.useState(false);

  useDidMountEffect(() => {
    setReload(!reload);
  }, [reloadConfig]);
  React.useEffect(() => {
    if (module == 'obozy') {
      setConfig({
        orderHiddenColumns: olOrderHiddenColumns[season],
        orderColumnsWidth: olOrderColumnsWidth[season],
        orderColumnsSequence: _.isNil(olOrderColumnsSequence[season]) ? olOrderColumnsSequence.main : olOrderColumnsSequence[season],
        orderFilters: olOrderFilters[season],
        orderSearchFields: _.isNil(olOrderSearchFields[season]) ? olOrderSearchFields.main : olOrderSearchFields[season]

      });
    } else if (module == 'zielone_szkoly') {
      setConfig({
        orderHiddenColumns: zsOrderHiddenColumns[season],
        orderColumnsWidth: zsOrderColumnsWidth[season],
        orderColumnsSequence: _.isNil(zsOrderColumnsSequence[season]) ? zsOrderColumnsSequence.main : zsOrderColumnsSequence[season],
        orderFilters: zsOrderFilters[season],
        orderSearchFields: _.isNil(zsOrderSearchFields[season]) ? zsOrderSearchFields.main : zsOrderSearchFields[season]
      });
    } else if (module == 'polkolonie') {
      setConfig({
        orderHiddenColumns: plOrderHiddenColumns[season],
        orderColumnsWidth: plOrderColumnsWidth[season],
        orderColumnsSequence: _.isNil(plOrderColumnsSequence[season]) ? plOrderColumnsSequence.main : plOrderColumnsSequence[season],
        orderFilters: plOrderFilters[season],
        orderSearchFields: _.isNil(plOrderSearchFields[season]) ? plOrderSearchFields.main : plOrderSearchFields[season]
      });
    } else if (module == 'wyjazdy_rodzinne') {
      setConfig({
        orderHiddenColumns: wrOrderHiddenColumns[season],
        orderColumnsWidth: wrOrderColumnsWidth[season],
        orderColumnsSequence: _.isNil(wrOrderColumnsSequence[season]) ? wrOrderColumnsSequence.main : wrOrderColumnsSequence[season],
        orderFilters: wrOrderFilters[season],
        orderSearchFields: _.isNil(wrOrderSearchFields[season]) ? wrOrderSearchFields.main : wrOrderSearchFields[season]
      });
    } else {
      setConfig({
        orderHiddenColumns: {},
        orderColumnsWidth: {},
        orderColumnsSequence: {},
        orderFilters: {},
        orderSearchFields: {}
      });
    }
  }, [
    season,
    reload,
    olOrderFilters,
    zsOrderFilters,
    plOrderFilters,
    wrOrderFilters,
    olOrderSearchFields,
    zsOrderSearchFields,
    plOrderSearchFields,
    wrOrderSearchFields,
    olOrderHiddenColumns,
    zsOrderHiddenColumns,
    plOrderHiddenColumns,
    wrOrderHiddenColumns,
    olOrderColumnsWidth,
    zsOrderColumnsWidth,
    plOrderColumnsWidth,
    wrOrderColumnsWidth,
    olOrderColumnsSequence,
    zsOrderColumnsSequence,
    plOrderColumnsSequence,
    wrOrderColumnsSequence
  ]);

  return config;
};
